// BodyType
import FormFieldBodyType, {FormSingleBodyType} from '@adv-mt/mt-form-body-type'
import FormFieldBodyTypeCategory, {FormBodyTypeCategoryBasicContent} from '@adv-mt/mt-form-body-type-category'
// Color
import FormFieldColor from '@adv-mt/mt-form-color'
// Doors
import FormFieldDoorsRange, {FormDoorsRangeInline} from '@adv-mt/mt-form-doors-range'
// Driven wheels
import FormDrivenWheels from '@adv-mt/mt-form-driven-wheels'
// Electric autonomy
import FormElectricAutonomy from '@adv-mt/mt-form-electric-autonomy'
// Electric battery capacity
import FormElectricBatteryCapacity from '@adv-mt/mt-form-electric-battery-capacity'
// Electric charging time
import FormElectricChargingTime from '@adv-mt/mt-form-electric-charging-time'
// Environmental label
import FormEnvironmentalLabel from '@adv-mt/mt-form-environmental-label'
// Equipment
import FormEquipment from '@adv-mt/mt-form-equipment'
// FuelType
import FormFuelType, {FormMultiFuelType, FormMultiFuelTypeBasicContent} from '@adv-mt/mt-form-fuel-type'
// Online services
import FormHasOnlineFinancing from '@adv-mt/mt-form-has-online-financing'
// Photo
import FormHasPhoto from '@adv-mt/mt-form-has-photo'
// Price drop
import FormHasPriceDrop from '@adv-mt/mt-form-has-price-drop'
// Online services
import FormReservation from '@adv-mt/mt-form-has-reservation'
// Stock
import FormHasStock from '@adv-mt/mt-form-has-stock'
// Warranty
import {FormCardHasWarranty} from '@adv-mt/mt-form-has-warranty'
// Hp
import FormFieldHp, {FormHpInline} from '@adv-mt/mt-form-hp'
// Certification
import FormFieldIsCertified from '@adv-mt/mt-form-is-certified'
// Kms
import FormFieldKms, {FormKmsBasicContent} from '@adv-mt/mt-form-kms'
// Litres
import FormFieldLitres, {FormLitresBasicContent} from '@adv-mt/mt-form-litres'
// Location
import {
  FormLocationBasicContent,
  FormLocationModalSelectPopover,
  FormLocationRightSelectPopover
} from '@adv-mt/mt-form-location'
// Luggage capacity
import FormFieldLuggageCapacity from '@adv-mt/mt-form-luggage-capacity'
// Make
import {FormTechnicalMake, FormTechnicalMakeBasicContent} from '@adv-mt/mt-form-make'
// Model
import {FormModelVersion, FormTechnicalModel, FormTechnicalModelVersion} from '@adv-mt/mt-form-model'
// OfferType
import FormOfferType from '@adv-mt/mt-form-offer-type'
// Only peninsula
import FormOnlyPeninsula from '@adv-mt/mt-form-only-peninsula'
// Price
import FormFieldPrice, {FormPriceBasicContent} from '@adv-mt/mt-form-price'
// Price rank
import FormPriceRank from '@adv-mt/mt-form-price-rank'
// Price type
import FormPriceTypeSelect from '@adv-mt/mt-form-price-type-select'
import FormPriceWithTabs from '@adv-mt/mt-form-price-with-tabs'
// Province
import {FormMultiNestedProvinceBasicContent, FormMultiProvince} from '@adv-mt/mt-form-province'
// Rating
import FormRating from '@adv-mt/mt-form-rating'
// Search text
import FormFieldSearchText from '@adv-mt/mt-form-search-text'
// Seats
import FormFieldSeatsRange from '@adv-mt/mt-form-seats-range'
// Category
import FormSelectCategory from '@adv-mt/mt-form-select-category'
// Seller type
import {FormSellerTypeSelect, FormSellerTypeSelectToggle} from '@adv-mt/mt-form-seller-type'
// MonthlySubscription
import FormFieldMonthlySubscriptionCommitment from '@adv-mt/mt-form-subscription-commitment'
import FormFieldMonthlySubscriptionFee from '@adv-mt/mt-form-subscription-fee'
// Transmission
import {FormTransmissionSelect, FormTransmissionSelectToggle} from '@adv-mt/mt-form-transmission'
// Vehicle state
import {FormVehicleStateSelect, FormVehicleStateSelectToggle} from '@adv-mt/mt-form-vehicle-state'
// Vehicles
import {
  FormVehiclesBasicContent,
  FormVehiclesCenterToCustomRelativePopoverWithoutVersion,
  FormVehiclesModalSelectPopover,
  FormVehiclesRightSelectPopover
} from '@adv-mt/mt-form-vehicles'
// Version
import {FormVersionBuilder} from '@adv-mt/mt-form-version'
// Year
import FormFieldYear, {FormYearBasicContent} from '@adv-mt/mt-form-year'

/**
 * Returns coches filters by default
 * The order of the switch cases does not matter
 */
export const getFilterComponentBy = ({
  FILTERS_GROUPS_IDS,
  FILTER_NAMES,
  filterName,
  isAdsSearchLite,
  isCoches,
  isMotos,
  isSearchSidebar,
  isSearchTopbar,
  pageName
}) => {
  const isTechnicalDetailsSearchPage =
    pageName === 'technical-details-search' || pageName === 'technical-details-search-results'

  const showLegacyFilters = isTechnicalDetailsSearchPage

  if (isMotos) {
    switch (filterName) {
      case FILTER_NAMES.BODY_TYPE_CATEGORY:
        if (isSearchTopbar) return FormBodyTypeCategoryBasicContent
        return FormFieldBodyTypeCategory
    }
  }

  switch (filterName) {
    case FILTER_NAMES.VEHICLES:
      if (isSearchTopbar) return FormVehiclesBasicContent
      if (isAdsSearchLite) return FormVehiclesCenterToCustomRelativePopoverWithoutVersion
      if (isSearchSidebar) return FormVehiclesRightSelectPopover
      return FormVehiclesModalSelectPopover
    case FILTER_NAMES.BODY_TYPE:
      return showLegacyFilters ? FormSingleBodyType : FormFieldBodyType
    case FILTER_NAMES.CATEGORY_2:
      return FormSelectCategory
    case FILTER_NAMES.COLOR:
      return FormFieldColor
    case FILTER_NAMES.DOOR:
      if (isSearchTopbar) return FormDoorsRangeInline
      return FormFieldDoorsRange
    case FILTER_NAMES.DRIVEN_WHEELS:
      return FormDrivenWheels
    case FILTER_NAMES.ELECTRIC_AUTONOMY:
      return FormElectricAutonomy
    case FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY:
      return FormElectricBatteryCapacity
    case FILTER_NAMES.ENVIRONMENTAL_LABEL:
      return FormEnvironmentalLabel
    case FILTER_NAMES.EQUIPMENTS:
      return FormEquipment
    case FILTER_NAMES.FUEL_TYPE:
      if (isSearchTopbar) return FormMultiFuelTypeBasicContent
      if (isTechnicalDetailsSearchPage) return FormFuelType
      return FormMultiFuelType
    case FILTER_NAMES.HAS_INSTALMENT:
      return FormPriceTypeSelect
    case FILTER_NAMES.HAS_PHOTO:
      return FormHasPhoto
    case FILTER_NAMES.HAS_PRICE_DROP:
      return FormHasPriceDrop
    case FILTER_NAMES.HAS_STOCK:
      return FormHasStock
    case FILTER_NAMES.RATING:
      return FormRating
    case FILTER_NAMES.HAS_WARRANTY:
      return FormCardHasWarranty
    case FILTER_NAMES.HP:
      if (isSearchTopbar) return FormHpInline
      return FormFieldHp
    case FILTER_NAMES.IS_CERTIFIED:
      return FormFieldIsCertified
    case FILTER_NAMES.KMS:
      if (isSearchTopbar) return FormKmsBasicContent
      return FormFieldKms
    case FILTER_NAMES.LITRES:
      if (isSearchTopbar) return FormLitresBasicContent
      return FormFieldLitres
    case FILTER_NAMES.LUGGAGE_CAPACITY:
      return FormFieldLuggageCapacity
    case FILTER_NAMES.MAKE:
      if (isSearchTopbar || isAdsSearchLite) return FormTechnicalMakeBasicContent
      return FormTechnicalMake
    case FILTER_NAMES.MODEL:
      if (showLegacyFilters) return FormTechnicalModel
      return FormModelVersion
    case FILTER_NAMES.MODEL_VERSION:
      return FormTechnicalModelVersion
    case FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT:
      return FormFieldMonthlySubscriptionCommitment
    case FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE:
      return FormFieldMonthlySubscriptionFee
    case FILTER_NAMES.OFFER_TYPE:
      return FormOfferType
    case FILTER_NAMES.ONLY_PENINSULA:
      return FormOnlyPeninsula
    case FILTER_NAMES.PRICE:
      if (isSearchTopbar) return FormPriceBasicContent
      if (isAdsSearchLite && isCoches) return FormPriceWithTabs
      return FormFieldPrice
    case FILTER_NAMES.PROVINCE:
      if (isSearchTopbar || isAdsSearchLite) return FormMultiNestedProvinceBasicContent
      return FormMultiProvince
    case FILTER_NAMES.SEARCH_TEXT:
      return FormFieldSearchText
    case FILTER_NAMES.SEAT:
      return FormFieldSeatsRange
    case FILTER_NAMES.SELLER_TYPE:
      if (showLegacyFilters) return FormSellerTypeSelect
      return isSearchSidebar ? FormSellerTypeSelect : FormSellerTypeSelectToggle
    case FILTER_NAMES.TRANSMISSION_TYPE:
      if (isSearchSidebar) return FormTransmissionSelectToggle
      return FormTransmissionSelect
    case FILTER_NAMES.VEHICLE_STATE:
      return isSearchSidebar || isAdsSearchLite ? FormVehicleStateSelect : FormVehicleStateSelectToggle
    case FILTER_NAMES.VERSION:
      return FormVersionBuilder
    case FILTER_NAMES.YEAR:
      if (isSearchTopbar) return FormYearBasicContent
      return FormFieldYear
    case FILTER_NAMES.PRICE_RANK:
      return FormPriceRank
    case FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID:
      return FormElectricChargingTime
    case FILTERS_GROUPS_IDS.LOCATION_PLACES_GROUP_ID:
      if (isSearchSidebar) return FormLocationRightSelectPopover
      if (isSearchTopbar) return FormLocationBasicContent
      return FormLocationModalSelectPopover
    case FILTER_NAMES.LOCATION:
      if (isSearchSidebar) return FormLocationRightSelectPopover
      if (isSearchTopbar) return FormLocationBasicContent
      return FormLocationModalSelectPopover
    case FILTER_NAMES.HAS_RESERVATION:
      return FormReservation
    case FILTER_NAMES.HAS_ONLINE_FINANCING:
      return FormHasOnlineFinancing

    default:
      return null
  }
}

export function getSearchFromUpdatedFields({BODY_TYPE_CATEGORY, FILTER_NAMES, pageName, search, field, value}) {
  const bodyTypeCategoriesIds = Object.values(BODY_TYPE_CATEGORY)
  const isCategory = bodyTypeCategoryId => bodyTypeCategoriesIds.includes(bodyTypeCategoryId)
  const newPage = 1
  if (field === FILTER_NAMES.VEHICLES) {
    const lastVehicle = value[value.length - 1]

    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.MAKE]: lastVehicle?.makeId,
      [FILTER_NAMES.MAKE_NAME]: lastVehicle?.name,
      model: {id: lastVehicle?.model?.id},
      version: lastVehicle?.version
    }
  }

  // Reset model and model version on make changes
  if (field === FILTER_NAMES.MAKE) {
    return {
      ...search,
      page: newPage,
      [field]: value?.id,
      [FILTER_NAMES.MAKE_NAME]: value?.name,
      model: {},
      [FILTER_NAMES.MODEL_VERSION]: undefined,
      [FILTER_NAMES.VEHICLES]: value?.id ? [{makeId: value.id, make: value.name}] : []
    }
  }

  if (field === FILTER_NAMES.MODEL) {
    return {
      ...search,
      page: newPage,
      [field]: value,
      version: undefined,
      [FILTER_NAMES.VEHICLES]: [{...search.vehicles?.[0], model: value, version: undefined}]
    }
  }

  if (field === FILTER_NAMES.VERSION) {
    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.VEHICLES]: [{...search.vehicles?.[0], version: value}]
    }
  }

  if (field === FILTER_NAMES.HAS_INSTALMENT) {
    const hasInstalment = value

    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.PRICE]: hasInstalment ? {from: null, to: null} : value,
      [FILTER_NAMES.INSTALMENT]: hasInstalment ? value : {from: null, to: null}
    }
  }

  if (pageName === 'home' && (field === FILTER_NAMES.PRICE || field === FILTER_NAMES.INSTALMENT)) {
    const isInstalmentFilter = field === FILTER_NAMES.INSTALMENT
    return {
      ...search,
      page: newPage,
      [FILTER_NAMES.PRICE]: isInstalmentFilter ? {from: null, to: null} : value,
      [FILTER_NAMES.INSTALMENT]: isInstalmentFilter ? value : {from: null, to: null},
      [FILTER_NAMES.HAS_INSTALMENT]: field === FILTER_NAMES.INSTALMENT && value.to !== null
    }
  }

  if (field === FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE) {
    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: {from: null, to: null}
    }
  }

  if (field === FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE) {
    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: {from: null, to: null}
    }
  }

  if (field === FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE) {
    return {
      ...search,
      page: newPage,
      fee: value,
      [field]: value
    }
  }

  if (field === FILTER_NAMES.LOCATION) {
    return {
      ...search,
      page: newPage,
      [field]: {
        lat: value.lat,
        long: value.long,
        radio: value.text ? value.radio : null,
        text: value.text,
        provinceId: value.provinceId ? value.provinceId : null
      },
      [FILTER_NAMES.PROVINCE]: []
    }
  }

  if (field === FILTER_NAMES.PROVINCE) {
    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.LOCATION]: {lat: null, long: null, radio: null, text: null}
    }
  }

  /* TO-DO: remove this specificity when possible.
   * BODY_TYPE_CATEGORY is not an actual filter but an artifact that can mean two different things, an array of bodyTypeIds or one of category2Ids.
   * A Tech-debt issue is to be created to raise the issue to UX and act on this piece of code accordingly ASAP.
   */
  if (field === FILTER_NAMES.BODY_TYPE_CATEGORY) {
    const category2Id = value.find(isCategory)
    const bodyTypeIds = value.filter(item => !isCategory(item))
    return {
      ...search,
      page: newPage,
      [field]: value,
      [FILTER_NAMES.BODY_TYPE]: bodyTypeIds,
      [FILTER_NAMES.CATEGORY_2]: category2Id
    }
  }

  return {...search, page: newPage, [field]: value}
}
